import { render } from "./GameTwoEntry.vue?vue&type=template&id=2f2a5c6f"
import script from "./GameTwoEntry.vue?vue&type=script&lang=js"
export * from "./GameTwoEntry.vue?vue&type=script&lang=js"

import "./GameTwoEntry.vue?vue&type=style&index=0&id=2f2a5c6f&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__